import { render, staticRenderFns } from "./PainelAreaFisica.vue?vue&type=template&id=a0e3b302"
import script from "./PainelAreaFisica.vue?vue&type=script&lang=js"
export * from "./PainelAreaFisica.vue?vue&type=script&lang=js"
import style0 from "./PainelAreaFisica.vue?vue&type=style&index=0&id=a0e3b302&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports